/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { Helmet } from "react-helmet-async";
import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Menu,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  CardContent,
  Grid,
  Link,
  tooltipClasses,
  Tooltip,
  styled,
  TooltipProps,
  Skeleton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import TableHeader from "./table-header";
import TableToolbar from "./table-toolbar";
import { GET, POST } from "../../../config/https";
import APIS from "../../../config/api";
import Color from "../../../theme/color";
import Iconify from "../../../components/iconify";
import FullScreenLoader, {
  ZIndexFullScreenLoader,
} from "../../../components/full-screen-loader";
import { Icon } from "@iconify/react";
import { GetLocalStorage, SetLocalStorage } from "../../../utils/local-storage";
import AutoCompleteDropDown from "../../../components/auto-complete-dropdown";
import { STRING } from "../../../resources/string";
import NumberFormat from "../../../components/number-format";
import { usePersistentState } from "../../../contexts/global-context";
import { marginBottomSize } from "../../../utils/constant";
import toast from "react-hot-toast";
import { allPaymentStatus } from "../../../assets/data/all-data";
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

export default function Orders() {
  const [state]: any = usePersistentState();
  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [eventList, setCategoryList] = useState([]);
  const [orderId, setOrderId] = useState(null);
  const [newOpen, setNewOpen] = useState({
    data: {},
    isOpen: false,
  });
  const [orderBy, setOrderBy] = useState("orderNo");
  const [isDescending, setIsDescending] = useState(true);
  const [sortProperty, setSortProperty] = useState("orderNumber");
  const [filterName, setFilterName] = useState("");
  const [orderList, setOrderList] = useState<any>([]);
  const [filterEvent, setFilterEvent] = useState<any>([]);
  const [pagination, setPagination] = useState<any>();
  const filterEventId = filterEvent?.id;
  const [openSection, setOpenSection] = useState<any>(null);
  const [openSectionData, setOpenSectionData] = useState<any>(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [zIndexLoader, setZIndexLoader] = useState(false);
  const [skeleton, setSkeleton] = useState(false);
  const [eventDataLoader, setEventDataLoader] = useState(false);
  const [allStatus, setAllStatus] = useState<any>(allPaymentStatus);
  const navigate = useNavigate();
  const [selectedStatusId, setSelectedStatusId] = useState<any>();
  const [allOrganizer, setAllOrganizer] = useState<any>([]);
  const [selectedOrganizers, setSelectedOrganizers] = useState({
    value: "",
    label: "",
  });
  const [organizerId, setOrganizerId] = useState({
    value: "",
    label: "",
  });
  const [loginInfo, setLoginInfo] = useState<any>({});
  const numberOfSkeletons = 3;
  const skeletons: any = [];
  let userData = GetLocalStorage("loginData");
  const TABLE_HEAD = [
    { id: "id", label: "", alignRight: false },
    { id: "orderNo", label: "Order No", alignRight: false },
    { id: "eventName", label: "Event Name", alignRight: false },
    { id: "customerName", label: "Customer Name", alignRight: false },
    { id: "email", label: "Email", alignRight: false },
    { id: "phone", label: "Phone", alignRight: false },
    { id: "noOfTicket", label: "No. of ticket", alignRight: false },
    { id: "paymentType", label: "Payment type", alignRight: false },
    { id: "status", label: "Status", alignRight: false },
    { id: "amount", label: "Amount", alignRight: false },
    { id: "action", label: "Action", alignRight: false },
  ];
  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData.roles);
  }, [state.users]);

  useEffect(() => {
    getAllUsers();
  }, [selectedOrganizers]);

  useEffect(() => {
    GetOrderList(page, rowsPerPage, filterEventId, selectedStatusId);
  }, [
    page,
    rowsPerPage,
    filterEventId,
    selectedStatusId,
    selectedOrganizers,
    loginInfo,
    organizerId,
    isDescending,
    sortProperty,
  ]);

  useEffect(() => {
    const delay = setTimeout(() => {
      GetOrderList(page, rowsPerPage, filterEventId, selectedStatusId);
    }, 1100);
    return () => clearTimeout(delay);
  }, [filterName]);

  useEffect(() => {
    let loggedInUser = GetLocalStorage("loginData");
    setOrganizerId({
      value: loggedInUser.id,
      label: loggedInUser.companyName,
    });
    GetEventDropdown();
    GetStatusList();
  }, []);

  const getAllUsers = async () => {
    await GET(APIS.GET_ALL_USER + `?PageSize=10000`)
      .then((res: any) => {
        if (res?.isSuccess) {
          const org = res?.result
            ?.filter((x: any) => x?.companyName)
            .map((x: any) => ({
              value: x.id,
              label: x.companyName,
            }));

          setAllOrganizer(org);
        }
      })
      .catch(() => {
        console.log("error");
      });
  };

  const GetOrderList = async (
    pageNumber: number,
    rowsPerPage: number,
    filterEventId?: any,
    selectedStatusId?: any
  ) => {
    const newId = filterEventId || "";
    const newStatusId = selectedStatusId || "";

    if (loginInfo?.name === "Admin") {
      setEventDataLoader(true);
      await POST(
        APIS.ORDER_WITH_TICKET +
          "?OrganizerId=" +
          selectedOrganizers.value +
          "&SearchValue=" +
          filterName +
          "&EventId=" +
          newId +
          "&PageNumber=" +
          pageNumber +
          "&PageSize=" +
          rowsPerPage +
          "&PaymentStatusId=" +
          newStatusId +
          "&IsDescending=" +
          isDescending +
          "&SortProperty=" +
          sortProperty
      )
        .then((res: any) => {
          setPagination(res);
          if (res?.isSuccess) {
            setOrderList(res.result);
          } else {
          }
        })
        .catch((error) => {})
        .finally(() => {
          setTimeout(() => {
            setEventDataLoader(false);
          }, 1500);
        });
    } else {
    }
    if (loginInfo?.name === "Host") {
      if (organizerId?.value) {
        setEventDataLoader(true);
        await POST(
          APIS.ORDER_WITH_TICKET +
            "?OrganizerId=" +
            organizerId.value +
            "&SearchValue=" +
            filterName +
            "&EventId=" +
            newId +
            "&PageNumber=" +
            pageNumber +
            "&PageSize=" +
            rowsPerPage +
            "&PaymentStatusId=" +
            newStatusId +
            "&IsDescending=" +
            isDescending +
            "&SortProperty=" +
            sortProperty
        )
          .then((res: any) => {
            setPagination(res);
            if (res?.isSuccess) {
              setOrderList(res.result);
            } else {
            }
          })
          .catch((error) => {})
          .finally(() => {
            setTimeout(() => {
              setEventDataLoader(false);
            }, 1500);
          });
      } else {
      }
    } else {
    }
  };

  const EventOrganizerId = selectedOrganizers?.value;
  const getOrganizerId = () => {
    if (EventOrganizerId) {
      return EventOrganizerId;
    }
    if (!EventOrganizerId && userData?.roles?.id === 1) {
      return "";
    }
    if (!EventOrganizerId && userData?.roles?.id === 2) {
      return userData?.id;
    }
  };
  const GetEventDropdown = async () => {
    let organizerId = await getOrganizerId();
    await GET(APIS.GET_ALL_EVENTS + "?OrganizerId=" + organizerId)
      .then((res: any) => {
        if (res?.isSuccess) {
          setCategoryList(res.result);
        } else {
          console.log("error");
        }
      })
      .catch((error) => {})
      .finally(() => {});
  };

  const handleClose = () => {
    setNewOpen({
      data: {},
      isOpen: false,
    });
    handleCloseMenu();
  };

  const handleViewTicket = (id: any) => {
    SetLocalStorage("customerId", id);
    navigate("/view-ticket");
  };

  const handleOnChange = (newValue: any) => {
    setFilterEvent(newValue);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event: any, property: any) => {
    let mappedProperty = property;
    if (property === "orderNo") {
      mappedProperty = "orderNumber";
    } else if (property === "customerName") {
      mappedProperty = "customerName";
    } else if (property === "email") {
      mappedProperty = "email";
    } else if (property === "phone") {
      mappedProperty = "string";
    } else if (property === "noOfTicket") {
      mappedProperty = "totalTicket";
    } else if (property === "status") {
      mappedProperty = "status";
    } else if (property === "paymentType") {
      mappedProperty = "paymentType";
    } else if (property === "amount") {
      mappedProperty = "totalAmount";
    }
    setSortProperty(mappedProperty);
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setIsDescending(order === "asc" ? true : false);
  };

  const GetStatusList = async () => {
    setLoader(true);

    await GET(APIS.ALL_PAYMENT_STATUS)
      .then((res: any) => {
        if (res?.isSuccess) {
          setAllStatus(res.result);
        } else {
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const updateStatus = async (newValue: any, orderId: any) => {
    setNewOpen({
      data: { newValue, orderId },
      isOpen: true,
    });
  };

  const UpdateByStatus = async (data: any) => {
    setNewOpen({
      data: {},
      isOpen: false,
    });
    setLoader(true);
    await POST(APIS.PAYMENT_STATUS_UPDATE + "?Id=" + data?.orderId + "&PaymentStatusId=" + data?.newValue?.id)
      .then((res: any) => {
        if (res?.isSuccess) {
          const orderItem = orderList.find((order: any) => order.id === data?.orderId);
          const orderIndex = orderList.findIndex((order: any) => order.id === data?.orderId);
          if (orderItem) {
            const updateOrder = { ...orderItem, statusId: data?.newValue?.id };
            const updateOrderItem = [...orderList];
            updateOrderItem[orderIndex] = updateOrder;
            setOrderList(updateOrderItem);
          }
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setNewOpen({ data: {}, isOpen: false });
        setLoader(false);
      });
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event: any) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const handleFilterByOrganizer = (event: any, newValue: any) => {
    if (newValue === null) {
      setSelectedOrganizers({ value: "", label: "" });
    } else {
      setSelectedOrganizers(newValue);
    }
  };

  const handleFilterByStates = (event: any, newValue: any) => {
    setSelectedStatusId(event?.id);
  };
    const handleExport = async (format: 'csv' | 'xlsx' | 'pdf') => {
        try {
            // 1. Determine Organizer ID
            let currentOrganizerId = "";
            if (loginInfo?.name === "Admin") {
                currentOrganizerId = selectedOrganizers?.value || "";
            } else if (loginInfo?.name === "Host") {
                currentOrganizerId = organizerId?.value || "";
            }

            const buildUrl = (pageSize: number) =>
                APIS.ORDER_WITH_TICKET +
                "?OrganizerId=" + currentOrganizerId +
                "&SearchValue=" + (filterName || "") +
                "&EventId=" + (filterEventId || "") +
                "&PageNumber=0" +
                "&PageSize=" + pageSize +
                "&PaymentStatusId=" + (selectedStatusId || "") +
                "&IsDescending=" + isDescending +
                "&SortProperty=" + sortProperty;

            // 2. Fetch Total Count then Fetch All Data
            const initialRes: any = await POST(buildUrl(1));
            if (!initialRes?.isSuccess) return alert("Failed to initialize export.");

            const totalCount = initialRes.totalRecords || 0;
            if (totalCount === 0) return alert("No records found.");

            const finalRes: any = await POST(buildUrl(totalCount));
            if (!finalRes?.isSuccess || !finalRes?.result) return;

            // 3. Map Data
            const dataToExport = finalRes.result.map((order: any) => ({
                "Order No": order.orderNumber ?? '',
                "Event Name": order.eventName ?? '',
                "Customer Name": order.customerName ?? '',
                "Email": order.email ?? '',
                "Phone": order.phone ?? '',
                "Amount": order.subTotal ?? 0,
                "Status": order.status ?? 'N/A',
                "Date": order.orderCreatedDate ? new Date(order.orderCreatedDate).toLocaleDateString() : ''
            }));

            const fileName = `Orders_Export_${new Date().toISOString().split('T')[0]}`;

            // 4. Export Logic based on format
            if (format === 'csv') {
                generateCSV(dataToExport, fileName);
            } else if (format === 'xlsx') {
                generateExcel(dataToExport, fileName);
            } else if (format === 'pdf') {
                generatePDF(dataToExport, fileName);
            }

        } catch (error) {
            console.error("Export error:", error);
            alert("An error occurred while exporting.");
        }
    };

    // --- HELPER FUNCTIONS ---

    const generateCSV = (data: any[], fileName: string) => {
        const headers = Object.keys(data[0]).join(',');
        const csvRows = data.map(row =>
            Object.values(row).map(val => `"${String(val).replace(/"/g, '""')}"`).join(',')
        ).join('\n');
        const blob = new Blob([`${headers}\n${csvRows}`], { type: 'text/csv;charset=utf-8;' });
        triggerDownload(URL.createObjectURL(blob), `${fileName}.csv`);
    };

    const generateExcel = (data: any[], fileName: string) => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };

    const generatePDF = (data: any[], fileName: string) => {
        try {
            const doc = new jsPDF('l', 'pt', 'a4');

            // Extract headers
            const headers = [Object.keys(data[0])];

            // Explicitly cast the body to any[][] to satisfy the RowInput type requirement
            const body = data.map(row => Object.values(row)) as any[][];

            doc.text("Orders Export", 40, 30);

            autoTable(doc, {
                head: headers,
                body: body,
                startY: 50,
                styles: { fontSize: 8, cellPadding: 3 },
                headStyles: { fillColor: [25, 118, 210] },
                margin: { top: 50 },
            });

            doc.save(`${fileName}.pdf`);
        } catch (error) {
            console.error("PDF Generation Error:", error);
            throw error;
        }
    };

    const triggerDownload = (url: string, fileName: string) => {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
  const handleOpenSection = async (rowData: any) => {
    setOpenSection(rowData?.id);
    setSkeleton(false);
    let data = await GET(
      `${APIS.GET_ORDER_ID_BY_TICKET}?orderId=${rowData?.id}`
    )
      .then((res: any) => {
        return res?.result;
      })
      .catch((error) => {
        console.log("error", error);
        return null;
      })
      .finally(() => {
        setSkeleton(true);
      });

    setOpenSectionData(data);
  };

  const isNotFound = (!orderList.length && !!filterName) || !orderList.length;

  const HandleDownloadTicket = async () => {
    setZIndexLoader(true);

    try {
      const response: any = await GET(
        `${APIS.DOWNLOAD_TICKET_PDF}?OrderId=${orderId}`
      );
      if (response) {
        fetch(response).then((response) => {
          response.blob().then((blob) => {
            const fileURL = window.URL.createObjectURL(blob);
            const downloadLink: any = document.createElement("a");
            downloadLink.href = fileURL;
            downloadLink.download = `EventPrix - ${orderId} - Ticket.pdf`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        });
      } else {
        console.error("Invalid response. Download link not found.");
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setZIndexLoader(false);
    }
  };
  const HandleSentEmail = async () => {
    setZIndexLoader(true);
    await GET(`${APIS.SEND_EMAIL}?OrderId=${orderId}`)
      .then(() => {
        toast.success("Email successfully sent");
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setZIndexLoader(false);
      });
  };

  for (let i = 1; i <= numberOfSkeletons; i++) {
    skeletons.push(
      <Skeleton
        key={i}
        sx={{
          bgcolor: "grey.150",
          borderRadius: "12px",
          margin: "15px 15px 0 10px",
          animationDuration: "1s",
        }}
        variant="rectangular"
        width={330}
        height={140}
      />
    );
    }
    // Inside your component function...
    const [exportAnchorEl, setExportAnchorEl] = useState<null | HTMLElement>(null);
    const exportMenuOpen = Boolean(exportAnchorEl);

    const handleExportClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setExportAnchorEl(event.currentTarget);
    };

    const handleExportClose = () => {
        setExportAnchorEl(null);
    };

    const handleExportOption = (format: 'csv' | 'xlsx' | 'pdf') => {
        handleExport(format);
        handleExportClose(); // Use the renamed close function
    };

  return (
    <>
      <Helmet>
        <title> Orders | EventPrix </title>
      </Helmet>

      <Container maxWidth={"xl"} style={{ marginBottom: marginBottomSize }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Icon
              width="30"
              height="30"
              style={{ marginRight: 5 }}
              icon="material-symbols:order-approve-outline"
            />
            <Typography variant="h4">Orders</Typography>
            </div>
                  <Button
                      variant="contained"
                      onClick={handleExportClick} // Updated name
                      startIcon={<Icon icon="solar:export-bold" />}
                      endIcon={<Icon icon="material-symbols:keyboard-arrow-down" />}
                  >
                      Export Orders
                  </Button>

                  <Menu
                      anchorEl={exportAnchorEl} // Updated name
                      open={exportMenuOpen}     // Updated name
                      onClose={handleExportClose} // Updated name
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                      <MenuItem onClick={() => handleExportOption('csv')}>
                          <ListItemIcon><Icon icon="ph:file-csv-bold" width="20" /></ListItemIcon>
                          <ListItemText>Export as CSV</ListItemText>
                      </MenuItem>

                      <MenuItem onClick={() => handleExportOption('xlsx')}>
                          <ListItemIcon><Icon icon="ph:file-xls-bold" width="20" color="#1D6F42" /></ListItemIcon>
                          <ListItemText>Export as Excel</ListItemText>
                      </MenuItem>

                      <MenuItem onClick={() => handleExportOption('pdf')}>
                          <ListItemIcon><Icon icon="ph:file-pdf-bold" width="20" color="#E91E63" /></ListItemIcon>
                          <ListItemText>Export as PDF</ListItemText>
                      </MenuItem>
                  </Menu>
        </Stack>
        <FullScreenLoader open={loader} />
        <Card>
          <TableToolbar
            filterName={filterName}
            onFilterName={handleFilterByName}
            category={eventList}
            onChange={(newValue: any) => {
              handleOnChange(newValue);
            }}
            options={allOrganizer}
            value={selectedOrganizers.label}
            onChangeOrganizer={handleFilterByOrganizer}
            statesData={allStatus}
            handleChangeStates={handleFilterByStates}
          />

          <TableContainer
            sx={{ minWidth: 300, minHeight: 300, overflow: "auto" }}
          >
            <Table>
              <TableHeader
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                onRequestSort={handleRequestSort}
                sortableColumns={[
                  "orderNo",
                  "customerName",
                  "email",
                  "phone",
                  "noOfTicket",
                  "status",
                  "paymentType",
                  "amount",
                ]}
              />

              <TableBody>
                {orderList?.map((order: any, index: any) => {
                  const {
                    id,
                    orderNumber,
                    customerName,
                    email,
                    phone,
                    paymentType,
                    paymentTypeId,
                    eventName,
                    subTotal,
                    discount,
                    statusId,
                    totalOrderItem,
                    status,
                  } = order;

                  let totalAmount = subTotal - discount;

                  let paymentStatus = allStatus.find(
                    (x: any) => x.id === statusId
                  );

                  return (
                    <React.Fragment key={index}>
                      <TableRow>
                        <TableCell align="center">
                          <Link onClick={() => handleOpenSection(order)}>
                            <Iconify icon={"clarity:plus-line"} />
                          </Link>
                        </TableCell>
                        <TableCell align="center">{orderNumber}</TableCell>
                        <TableCell align="center">{eventName}</TableCell>
                        <TableCell align="center">{customerName}</TableCell>

                        <TableCell align="center">{email}</TableCell>
                        <TableCell align="center">{phone}</TableCell>
                        <TableCell align="center">{totalOrderItem}</TableCell>
                        <TableCell align="center">
                          {STRING.PAYMENT_TYPE_ID.ZELLE === paymentTypeId ? (
                            <LightTooltip title={paymentType}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={require("../../../assets/icons/icons8-zelle-48.png")}
                                  height={30}
                                />
                              </div>
                            </LightTooltip>
                          ) : (
                            <>
                              {STRING.PAYMENT_TYPE_ID.CARD === paymentTypeId ? (
                                <LightTooltip
                                  title={paymentType}
                                  placement="top-start"
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <img
                                      src={require("../../../assets/icons/credit.png")}
                                      height={30}
                                    />
                                  </div>
                                </LightTooltip>
                              ) : (
                                <>
                                  {STRING.PAYMENT_TYPE_ID.PAY_TO_HOST ===
                                  paymentTypeId ? (
                                    <LightTooltip
                                      title={paymentType}
                                      placement="top-start"
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <img
                                          src={require("../../../assets/icons/cash-on-delivery.png")}
                                          height={30}
                                        />
                                      </div>
                                    </LightTooltip>
                                  ) : (
                                    <LightTooltip
                                      title={paymentType}
                                      placement="top-start"
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <img
                                          src={require("../../../assets/icons/free.png")}
                                          height={30}
                                        />
                                      </div>
                                    </LightTooltip>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {order?.paymentTypeId === 1002 &&
                          loginInfo?.displayName === "Host" ? (
                            <AutoCompleteDropDown
                              style={{ width: 190 }}
                              data={allStatus}
                              onChange={(newValue) => {
                                updateStatus(newValue, id);
                              }}
                              disabled={true}
                              value={paymentStatus}
                              label={"displayName"}
                              dropDownDisplayLabel={"Status"}
                              placeholder={"Select Status"}
                            />
                          ) : (
                            <AutoCompleteDropDown
                              style={{ width: 190 }}
                              data={allStatus}
                              onChange={(newValue) => {
                                updateStatus(newValue, id);
                              }}
                              value={paymentStatus}
                              label={"displayName"}
                              dropDownDisplayLabel={"Status"}
                              placeholder={"Select Status"}
                            />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          $<NumberFormat total={totalAmount} />
                        </TableCell>

                        <TableCell align="center">
                          {statusId === 2 ? (
                            <IconButton
                              size="large"
                              color="inherit"
                              onClick={(event: any) => {
                                setOrderId(id);
                                setOpen(event.currentTarget);
                              }}
                            >
                              <Iconify icon={"eva:more-vertical-fill"} />
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </TableCell>
                      </TableRow>
                      {openSection === id && (
                        <TableRow>
                          <TableCell colSpan={12}>
                            <Grid container spacing={2}>
                              {openSectionData?.map(
                                (items: any, index: any) => {
                                  return (
                                    <>
                                      {skeleton ? (
                                        <Grid
                                          key={index}
                                          item
                                          xs={3}
                                          sm={3}
                                          md={3}
                                          style={{
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textAlign: "center",
                                            height: "100%",
                                          }}
                                        >
                                          <Card>
                                            <CardContent>
                                              <Typography variant="body1">
                                                <b>Ticket No : </b>
                                                {items.id}
                                              </Typography>
                                              <Typography variant="body1">
                                                <b>Ticket type : </b>
                                                {items.ticketType}
                                              </Typography>
                                              <Button
                                                style={{
                                                  backgroundColor:
                                                    Color.primary,
                                                  margin: "5px 5px 5px 0 ",
                                                }}
                                                variant="contained"
                                                onClick={(id) => {
                                                  handleViewTicket(items.id);
                                                }}
                                              >
                                                <b>View Ticket</b>
                                              </Button>
                                            </CardContent>
                                          </Card>{" "}
                                        </Grid>
                                      ) : (
                                        <div
                                          style={{
                                            flexDirection: "row",
                                            display: "flex",
                                          }}
                                        >
                                          {skeletons}
                                        </div>
                                      )}
                                    </>
                                  );
                                }
                              )}
                            </Grid>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  );
                })}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={11} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          alignItems: "center",
                          textAlign: "center",
                          height: "160px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <Typography variant="h5" paragraph>
                          No Data found
                        </Typography>
                        {filterName ? (
                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete
                            words.
                          </Typography>
                        ) : (
                          ""
                        )}
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={pagination?.totalRecords ?? 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{ overflow: "auto" }}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 250,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
            zIndex: 1200,
          },
        }}
      >
        <MenuItem
          onClick={async () => {
            await HandleDownloadTicket();
          }}
        >
          <Iconify icon={"bxs:download"} sx={{ mr: 2 }} />
          Download Ticket
        </MenuItem>
        <MenuItem
          onClick={async () => {
            await HandleSentEmail();
          }}
        >
          <Iconify icon={"ic:round-email"} sx={{ mr: 2 }} />
          Re-send ticket to email
        </MenuItem>
      </Popover>

      <FullScreenLoader open={loader} />
      <FullScreenLoader open={eventDataLoader} />
      <ZIndexFullScreenLoader open={zIndexLoader} />
      <Dialog
        open={newOpen.isOpen}
        onClose={handleClose}
        aria-labelledby="delete-dialog-title"
      >
        <DialogTitle id="delete-dialog-title">Confirm Update</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to change status?</Typography>
        </DialogContent>
        <DialogActions>
          <Button style={{ color: "black" }} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            onClick={() => UpdateByStatus(newOpen.data)}
            variant="contained"
            sx={{
              backgroundColor: Color.green,
              "&:hover": { backgroundColor: Color.green },
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
